
const embedDataHandler = (data) => {

  if (data.assets) {

    const assets = [];

    // Get a list of unique spinset tags from context field "spinset_tag"
    const spinsets = data.assets
      .map(asset => getContext(asset, 'spinset_tag')) // create array
      .filter((tag, i, arr) => tag && arr.indexOf(tag) === i); // unique

    data.assets.forEach((asset) => {
      // Find a spinset tag, if exist
      const spin = asset.tags && asset.tags.filter(tag => spinsets.includes(tag))[0];

      if (spin) {
        // Push the spinset if it's not there already
        if (!assets.some((a) => a.mediaType == 'spin' && a.tag == spin)) {
          const item = {
            tag: spin,
            mediaType: 'spin'
          };
          if (getContext(asset, 'placement')) {
            item.placement = getContext(asset, 'placement');
          }
          assets.push(item);
        }
      }
      else {
        // Push the individual asset
        const item = {
          publicId: asset.public_id,
          mediaType: (asset.resource_subtype || asset.resource_type || 'image').toLowerCase(),
        };
        if (getContext(asset, 'placement')) {
          item.placement = getContext(asset, 'placement');
        }
        assets.push(item);
      }

    });

    // Sort
    const typeOrders = ['image', 'video', 'spin', '3d'];
    assets.sort((a, b) => {
      // Sort by 'placement' context
      if (a.placement || b.placement) {
        if (!a.placement) {
          return 1;
        }
        else if (!b.placement) {
          return -1;
        }
        return parseInt(a.placement, 10) - parseInt(b.placement, 10);
      }
      // Sort by 'image' => 'video' => 'spin' => '3d'
      else if (a.mediaType != b.mediaType) {
        return (typeOrders.indexOf(a.mediaType) - typeOrders.indexOf(b.mediaType));
      }
      // Sort alphabetically
      else {
        return (a.publicId + '').localeCompare(b.publicId, undefined, {numeric: true});
      }
    });

    // Cleanup
    assets.forEach(i => delete i.placement );

    return assets;
  }

};

// Utility function - extract context value
const getContext = (asset, key) => {
  if (asset.context && asset.context.length > 0) {
    const ctx = asset.context.find(cx => cx.key === key);
    return ctx ? ctx.value : false;
  }
  return false;
};

export {
  embedDataHandler
};
